export const SET_GAINSIGHT_LOADED = 'base/SET_GAINSIGHT_LOADED';

export const setGainsightLoaded = payload => ({
  type: SET_GAINSIGHT_LOADED,
  payload,
});
